<script setup lang="ts">
    import { Invoice } from '@/types';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import ContinueButton from '@/components/ContinueButton.vue';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();

    const props = defineProps<{
        invoice: Invoice;
    }>();

    const downloadInvoice = () => {
        window.open(
            route('v2.dashboard.invoices.download', { id: props.invoice.booked_invoice_number }),
            '_blank',
        );
    };
</script>

<template>
    <DataTableActions :data="invoice">
        <ContinueButton @click="downloadInvoice">
            {{ t('dashboards.invoices.download') }}
        </ContinueButton>
    </DataTableActions>
</template>
